import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// import { AuthenticationService } from '@app/_services';
import { NgStrapiAuthService } from './ng-strapi-auth.service';

@Injectable()
export class NgStrapiErrorInterceptor implements HttpInterceptor {
  constructor(private authSrv: NgStrapiAuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        console.log('NgStrapiErrorInterceptor', err);
        if (err.status === 401) {
          // auto logout if 401 response returned from api
          this.authSrv.signOut();
          location.reload(true);
        }

        const error = err.error.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
}
